import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Widget from 'cms/Widget'
import QuotesList from './QuotesList'

const View = ({ data, loading, error, ...props }) => {
  return (
    <Widget>
      {loading ? (
        <Typography align="center">Loading quotes...</Typography>
      ) : (
        <div>
          {data && <QuotesList {...data} {...props} />}
          {error && (
            <Typography align="center" color="error">
              An error occurred!
              <br />
              {error.message}
            </Typography>
          )}
        </div>
      )}
    </Widget>
  )
}

View.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  selectQuote: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  mostRecentRequest: PropTypes.string,
  quoteRef: PropTypes.func.isRequired,
  authorRef: PropTypes.func.isRequired,
  tagsRef: PropTypes.func.isRequired,
}

export default View



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/View.js